import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 7, viewBox: "0 0 8 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.10292 6.75L0.205811 0H8.00004L4.10292 6.75Z", fill: "#3E6378" }));
export default SvgArrowDown;
